import React from "react";
import "./LoginPage.css";
import LoginForm from "./components/LoginForm";
import InfoSection from "./components/InfoSection";

const LoginPage = () => {
  return (
    <div className="login-container">
      <div className="login-box">
        <LoginForm />
        <InfoSection />
      </div>
    </div>
  );
};

export default LoginPage;